
<div class='container-fluid'>
    <app-menu></app-menu>
    <router-outlet></router-outlet>
</div>